<template>
  <div>
    <b-container fluid class="px-5">
      <div class="mt-4 d-flex justify-content-between">
          <back-arrow title="Ajouter un propriétaire"/>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

      <UserForm
        :createHospitalization="createHospitalization"
      ></UserForm>

      </b-card>
    </b-container>
  </div>
</template>

<script>
    import BackArrow from "../../components/BackArrow";
    import UserForm from "./UserForm";

    export default {
        name: "UserCreate",

        components: {
            BackArrow,
            UserForm
        },

        methods: {

        },

        data() {
          return {
            createHospitalization: this.$route.params.createHospitalization,
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/UserCreate.vue